import React, { useState, useEffect } from "react";
import {Card, Typography, Button, Box, ListItemIcon} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import LooksOneRoundedIcon from '@mui/icons-material/LooksOneRounded';
import LooksTwoRoundedIcon from '@mui/icons-material/LooksTwoRounded';
import Looks3RoundedIcon from '@mui/icons-material/Looks3Rounded';
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import './EstiloCardsIndividual.css';

import { IconUser, IconSquareNumber1, IconSquareNumber2, IconSquareNumber3, IconSquare4 } from '@tabler/icons';


function CardsIndividual(props) {
  const params= useParams();
  const navigate = useNavigate();
  const [res, updateRes] = useState([]);

  const routeChange = (props) => {
    navigate(`/auth/contratos/registrarhrspersona/cargaindividual/${params.id}`,{ state: { contratoElegido: props } });
    };

localStorage.setItem('contratoElegido', JSON.stringify(props.dataContrato));
let StorageTest = JSON.parse(localStorage.getItem('contratoElegido'));

  useEffect(() => {
  }, [params]);


  return (
    <>
      <section className="caja-estilos-SeleccionarContrato">
          <header className="caja-estilos-SeleccionarContrato-header">
          <IconUser
                size={20}
                color="white"
                stroke={2.5}
                style={{ marginRight:5 }}  
              />
              Carga Individual
          </header>
          <main>
            <div className="caja-estilos-SeleccionarContrato-contenido">
              <div className="caja-estilos-SeleccionarContrato-contenido-textos">
                <ul>
                  <li className="contenido-fila-cargaIndividual">
                  <IconSquareNumber1
                      size={20}
                      color="black"
                      stroke={2}
                      style={{ marginRight:5 }}  
                  />Revisar el listado de profesionales
                  asociados a <br/>su contrato  u orden de
                  compra.</li>
                  <li className="contenido-fila-cargaIndividual">
                  <IconSquareNumber2
                      size={20}
                      color="black"
                      stroke={2}
                      style={{ marginRight:5 }}  
                  />Selecciona el tipo de hora: Laborales, permisos <br/>o vacaciones.</li>
                  <li className="contenido-fila-cargaIndividual">
                  <IconSquareNumber3
                      size={20}
                      color="black"
                      stroke={2}
                      style={{ marginRight:5 }}  
                  />Registra las horas que laboró.</li>
                </ul>
              </div>
              <div className="caja-estilos-SeleccionarContrato-contenido-boton">
                <Button
                  variant="contained"
                  color="primary"
                  className="boton_seleccionar"
                  type="submit" 
                  onClick={() => routeChange(props)}>
                  Seleccionar
                </Button>
              </div>
            </div>
          </main>
      </section>
    </>
  );
}

export default CardsIndividual;